import { ChallengeStatus } from '../models/challenge';
import dayjs from 'dayjs';
import { ChallengeState } from '../models/challenge';

export function challengeStateTranslator(
  status: ChallengeStatus,
  deadline: string
): ChallengeState {
  if (dayjs().isAfter(deadline) && status !== ChallengeStatus.COMPLETED) {
    return 'wrong';
  }
  switch (status) {
    case ChallengeStatus.NOT_STARTED:
      return 'not-started';
    case ChallengeStatus.COMPLETED:
      return 'completed';
    case ChallengeStatus.PENDING:
      return 'pending';
    case ChallengeStatus.FAILED:
      return 'wrong';
    case ChallengeStatus.STARTED:
      return 'in-progress';
    default:
      return 'not-started';
  }
}
